module.exports = __webpack_public_path__ + "static/img/Tom-Raudonikis.fe980de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Raudonikis.jpg
// module id = wuiI
// module chunks = 0